import { normalize_text } from './view_case_details_helpers';

export function as_array(value) {
  return Array.isArray(value) ? value : [];
}

export function default_display_people() {
  return [
    {
      key: 'unassigned',
      initials: 'U',
      class: 'bg-secondary',
      name: 'Unassigned',
      role: 'No users assigned to this case yet',
    },
  ];
}

export function build_risk_decision_options(active_index) {
  return [
    {
      key: 'decline',
      label: 'Decline',
      description: 'Risk is too high to approve without rejection or senior escalation.',
    },
    {
      key: 'inspect',
      label: 'Inspect, then decide',
      description: 'Risk is material. Validate the facts before confirming the outcome.',
    },
    {
      key: 'pay',
      label: 'Pay in full',
      description: 'Risk is low enough to proceed if the case facts are complete.',
    },
  ].map((option, index) => ({
    ...option,
    active: index === active_index,
  }));
}

export function display_summary_row(component, row) {
  const value = summary_row_value(component, row.label);
  return value === undefined ? row : { ...row, value };
}

export function display_tab(component, tab) {
  const labels = display_tab_labels(component);
  return labels.has(tab.key) ? { ...tab, label: labels.get(tab.key) } : tab;
}

export const lifecycle_step = (status, index, current_id, next_id, current_index) =>
  lifecycle_step_record(status, index, lifecycle_step_flags(status, index, current_id, next_id, current_index));

function lifecycle_step_flags(status, index, current_id, next_id, current_index) {
  const status_id = Number(status.id);
  const is_current = status_id === current_id;
  const is_next = !is_current && status_id === next_id;
  const is_complete = current_index >= 0 && index < current_index;

  return { is_current, is_next, is_complete };
}

function lifecycle_step_record(status, index, flags) {
  return {
    ...status,
    position: index + 1,
    marker: flags.is_complete ? 'check' : index + 1,
    state: lifecycle_step_state(flags),
    helper: lifecycle_step_helper(flags),
  };
}

export function selected_decision_status(component) {
  return as_array(component.valid_next_statuses).find((status) =>
    Number(status.id) === Number(component.selected_decision_status_id)
  ) || null;
}

export function decision_is_final_status(component) {
  return Boolean(
    component.current_workflow_status?.is_final
    || (!component.loading_decision_workflow && component.current_workflow_status && !as_array(component.valid_next_statuses).length)
  );
}

export function filtered_reassign_panel_members(component) {
  const search = normalize_text(component.reassign_search).toLowerCase();
  const members = as_array(component.reassign_panel_members);
  if (!search) return members;

  return members.filter((member) =>
    `${member.name} ${member.detail} ${member.badge}`.toLowerCase().includes(search)
  );
}

function display_tab_labels(component) {
  return new Map([
    ['documents', `Documents (${component.display_document_count})`],
    ['time', `Time (${component.time_journal_summary.total_hours}h)`],
  ]);
}

function summary_row_value(component, label) {
  const values = summary_row_values(component);
  return values.get(label);
}

function summary_row_values(component) {
  return new Map([
    ['Hours logged', `${component.time_journal_summary.total_hours}h`],
    ['Owner', component.owner_summary_value],
    ['Coordinator', component.coordinator_summary_value],
    ['Domain', component.backend_domain_label],
    ['Claim type', component.backend_domain_label],
    ['Decision due', component.display_sla_runtimes[0]?.due_label || ''],
  ]);
}

function lifecycle_step_state(flags) {
  if (flags.is_current) return 'current';
  if (flags.is_next) return 'next';
  return flags.is_complete ? 'complete' : 'pending';
}

function lifecycle_step_helper(flags) {
  if (flags.is_current) return 'Current';
  if (flags.is_next) return 'Next';
  return flags.is_complete ? 'Complete' : '-';
}
